import React from 'react';
import styled from 'styled-components';
import {
  wMBold, primaryHeadingColor, secondaryFont, maxTablet,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  height: 300px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  h3 {
    font-size: 32px;
    font-family: ${secondaryFont};
    font-weight: ${wMBold};
    color: ${primaryHeadingColor};
    letter-spacing: -0.727273px;
    line-height: 20px;
    @media all and (max-width: ${maxTablet}){
      font-size: 18px;
    }
  }
`;

type Props = {
  title?: string,
} & typeof defaultProps;

const defaultProps = {
  title: '',
};

const NoUpdatesToShow = function NoUpdatesToShow(props: Props) {
  const { title } = props;
  return (
    <Wrapper>
      <h3>{title}</h3>
    </Wrapper>
  );
};

NoUpdatesToShow.defaultProps = defaultProps;
export default NoUpdatesToShow;
